import 'vuetify/dist/vuetify.min.css';

import Vue from 'vue';
import VueTelInputVuetify from 'vue-tel-input-vuetify';
// vuetify components used in .vue files will be imported automatically
// any used outside of .vue files (*.php) will need to be imported/exported here and will then be available globally
import Vuetify from 'vuetify';

Vue.use(Vuetify);

const bandwangoColors = {
  green: {
    base: '#82BE00',
    lighten5: '#F2F9E5'
  },
  'blue-grey': {
    base: '#003E52'
  }
};

const vuetifyOpts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        'bw-primary': bandwangoColors.green,
        'bw-secondary': bandwangoColors['blue-grey'],
        primary: '#82BA0C',
        secondary: '#49B2E4',
        accent: '#E450B5',
        info: '#4ea9e6',
        error: '#d26a5c'
      }
    }
  },
  css: {
    extract: { ignoreOrder: true }
  }
};

export default new Vuetify(vuetifyOpts);
